/**
 * Turns a two-letter ISO country code in [data-lm-country-flag] into a flag
 * emoji. Runs on load and again whenever the Theme Editor re-renders a
 * section, so flags survive section reloads.
 */
(function () {
  'use strict';

  function renderFlags(root) {
    (root || document).querySelectorAll('[data-lm-country-flag]').forEach(function (el) {
      const code = (el.getAttribute('data-lm-country-flag') || '').trim().toUpperCase();
      if (!/^[A-Z]{2}$/.test(code)) return;
      const a = code.charCodeAt(0) - 65;
      const b = code.charCodeAt(1) - 65;
      if (a < 0 || a > 25 || b < 0 || b > 25) return;
      el.textContent = String.fromCodePoint(0x1f1e6 + a, 0x1f1e6 + b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      renderFlags();
    });
  } else {
    renderFlags();
  }

  document.addEventListener('shopify:section:load', function (event) {
    renderFlags(event.target);
  });
})();
